import script from "./SendLoginCodeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SendLoginCodeButton.vue?vue&type=script&setup=true&lang=js"

import "./SendLoginCodeButton.vue?vue&type=style&index=0&id=fc142e26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc142e26"]])

export default __exports__